import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  SearchMovie(payload) {
    return Api().get(`/api/admin/searchmovies?s=${payload.search}`);
  },
  GetsearchMovieDetails(payload) {
    return Api().post(`/api/admin/getsearchmoviedetails`, payload);
  },
  AddMovie(payload) {
    // return Api().post(`/movie/add-movie`, payload)
    return Api().post(`/api/admin/insertmovie`, payload);
  },
  GetMovies(payload) {
    // return Api().get(`/movie/movielist?limit=${payload.limit}&currentPage=${payload.currentPage}`)
    return Api().get(
      `/api/admin/getmovieslist?searchValue=${payload.searchValue}&limit=${payload.limit}&currentPage=${payload.currentPage}`
    );
  },
  GetMovies2(payload) {
    // return Api().get(`/movie/movielist?limit=${payload.limit}&currentPage=${payload.currentPage}`)
    if (payload.status) {
      return Api().get(
        `/api/admin/getmovies?searchKey=${payload.searchKey}&searchValue=${payload.searchValue}&limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&status=${payload.status}&region_id=${payload.region_id}`
      );
    } else {
      return Api().get(
        `/api/admin/getmovies?searchKey=${payload.searchKey}&searchValue=${payload.searchValue}&limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
      );
    }
  },
  GetEditMoviesDetails(payload) {
    // return Api().get(`/movie/viewmovie/${payload.movie_details_id}`)
    return Api().get(`/api/admin/getviewmoviedetails/${payload.movie_id}`);
  },
  updateMovie(payload) {
    // return Api().put(`/movie/updatemovie/${payload.movie_details_id}`, payload)
    return Api().put(
      `/api/admin/updatemoviedetails/${payload.movie_id}`,
      payload
    );
  },
  updateMovieV2(payload) {
    // return Api().put(`/movie/updatemovie/${payload.movie_details_id}`, payload)
    return Api().put(
      `/api/admin/update-movie-all-steps/${payload.movie_id}`,
      payload
    );
  },
  updateMovieJob(payload) {
    let body = payload;

    return Api().post(`/jobs_over_http/add`, {
      body,
      method: "PUT",
      job_type: "UPDATE_MOVE",
    });
  },
  updateMovieupdateStep1(payload) {
    return Api().put(
      `/api/admin/updatemoviedetails/updateStep1/${payload.movie_id}?step=1`,
      payload
    );
  },
  updateMovieupdateStep2(payload) {
    return Api().put(
      `/api/admin/updatemoviedetails/updateStep2/${payload.movie_id}?step=2`,
      payload
    );
  },
  updateMovieupdateStep3(payload) {
    return Api().put(
      `/api/admin/updatemoviedetails/updateStep3/${payload.movie_id}?step=3`,
      payload
    );
  },
  updateMovieupdateStep4(payload) {
    return Api().put(
      `/api/admin/updatemoviedetails/updateStep4/${payload.movie_id}?step=4`,
      payload
    );
  },
  updateMovieupdateStep5(payload) {
    return Api().put(
      `/api/admin/updatemoviedetails/updateStep5/${payload.movie_id}?step=5`,
      payload
    );
  },
  updateMovieupdateStep6(payload) {
    return Api().put(
      `/api/admin/updatemoviedetails/updateStep6/${payload.movie_id}?step=6`,
      payload
    );
  },
  updateMovieupdateStep7(payload) {
    return Api().put(
      `/api/admin/updatemoviedetails/updateStep7/${payload.movie_id}?step=7`,
      payload
    );
  },
  updateMovieupdateStep8(payload) {
    return Api().put(
      `/api/admin/updatemoviedetails/updateStep8/${payload.movie_id}?step=8`,
      payload
    );
  },
  GetActiveMoviesWithFormat(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/activemovies/${query}`);
  },
  GetActiveDetailsMoviesWithFormatByMasterMovieID(payload) {
    return Api().get(`/api/admin/activemoviedetails/${payload.movie_id}`);
  },
  GetActiveMasterMovies(payload) {
    if (payload && payload.hasOwnProperty("movie_is_active")) {
      return Api().get(`/api/admin/tablelist/ms_movies?movie_is_active=Y`);
    } else {
      return Api().get(`/api/admin/tablelist/ms_movies`);
    }
  },
  GetMovieContentLanguages() {
    return Api().get(`/api/admin/getmoviecontentlanguage`);
  },
  UpdateTSMID(payload) {
    return Api().post(`/api/admin/tms`, payload);
  },
  GetDeeplTranslations(payload) {
    return Api().post(`/api/admin/deepl-transations`, payload);
  },
  GetExternalMovies(payload) {
    return Api().get(
      `/api/admin/external_movies?searchValue=${payload.search}`
    );
  },
  GetSingleExternalMovie(payload) {
    return Api().get(`/api/admin/external_movies/${payload.suisa_id}`);
  },
  FetchCinePoolMovie(payload) {
    return Api().get(`/api/admin/fetch_external_movies/${payload.suisa_id}`);
  },
  GetDefaultScreeingTypes() {
    return Api().get(`/api/admin/default_screening_type`);
  },
  AddMovieRateCard(payload) {
    return Api().post(`/api/admin/movie_rate_card`, payload);
  },
  GetMovieRateCard(payload) {
    return Api().get(`/api/admin/movie_rate_card/${payload.md_id}`);
  },
  SearchMoviesOnCentral(payload) {
    return Api().get(
      `/api/admin/search-movie-central?movie_name=${payload["movie_name"]}`
    );
  },
  SyncMovieFromCentral(payload) {
    return Api().get(`/api/admin/sync-movie-from-central/${payload.movie_id}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/MovieService.js